var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCurrentTheme } from '../../../../../hooks/useCurrentTheme';
import ColorsControlSection from '../ColorsControlSection/ColorsControlSection';
import { SettingsButtons } from './SettingsButtons';
import styles from './TextSettings.module.scss';
import { Scrollbars } from 'react-custom-scrollbars';
import CellSettings from './CellSettings';
import { useTypeSelector } from '../../../../../hooks/useTypeHooks';
import { selectCommonPreferences } from '../../../../../Redux/selectors/selectors';
var sections = [
    {
        title: 'Text shadow',
        settingProperty: 'textShadow',
        setting: 'shadow',
        advanced: 'shadow',
    },
    {
        title: 'Text size',
        settingProperty: 'textSize',
        setting: 'size',
        advanced: 'textSize',
    },
];
var TextAndCellSettings = function () {
    var currentTheme = useCurrentTheme();
    var matrix = useTypeSelector(selectCommonPreferences).matrix;
    var fontSize1player = matrix.fontSize1player, fontSize2player = matrix.fontSize2player, shadow = matrix.shadow;
    var defaultCommonSettings = {
        size: [
            {
                themeValue: fontSize1player,
                mode: 'One player',
                type: 'fontSize1player',
                advanced: 'textSize',
            },
            { themeValue: fontSize2player, mode: 'Two players', type: 'fontSize2player' },
        ],
        shadow: [
            {
                themeValue: shadow,
                mode: 'General',
                type: 'shadow',
                advanced: 'shadow',
            },
        ],
    };
    return (_jsx("div", __assign({ style: { width: '56%', height: 'calc(100% - 40px)' } }, { children: _jsx("div", __assign({ style: { height: '100%' } }, { children: _jsxs(Scrollbars, __assign({ renderTrackHorizontal: function (props) { return _jsx("div", __assign({}, props, { style: { display: 'none' } })); }, renderThumbVertical: function (_a) {
                    var style = _a.style, props = __rest(_a, ["style"]);
                    return (_jsx("div", __assign({}, props, { style: __assign(__assign({}, style), { backgroundColor: '#5a6268', borderRadius: '3px' }) })));
                } }, { children: [_jsx(ColorsControlSection, { isDrawer: true, type: 'matrix', title: 'substrate' }), sections.map(function (section) {
                        var _a;
                        return (_jsxs("div", __assign({ className: styles.sectionWrapper }, { children: [_jsx("h3", { children: section.title }), (_a = defaultCommonSettings[section.setting]) === null || _a === void 0 ? void 0 : _a.map(function (item) { return (_jsxs("div", __assign({ className: styles.buttonsWrapper }, { children: [_jsx("div", { children: item.mode }), _jsx(SettingsButtons, { type: item.type, themeValue: item.themeValue, setting: section.setting, isDisable: item.isDisable })] }), item.mode)); })] }), section.title));
                    }), _jsxs("div", __assign({ className: styles.sectionWrapper }, { children: [_jsx("h3", { children: "Cell" }), _jsx(CellSettings, { currentTheme: currentTheme })] }))] })) })) })));
};
export default TextAndCellSettings;
